import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Components
import Button from '../../../../../shared/Button'

// Styles
import styles from './OnboardingButton.module.scss'

const propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool
}

const OnboardingButton = ({ className, selected, ...restProps }) => (
  <Button className={classnames(styles.root, selected && styles.selected, className)} {...restProps} />
)

OnboardingButton.propTypes = propTypes

export default OnboardingButton
